import { z } from "zod";

export const activateDeviceSchema = z.object({
  deviceFingerprint: z.string().optional(),
  deviceName: z.string().optional(),
  platform: z.string().optional(),
  appVersion: z.string().optional()
});

export const revokeDeviceSchema = z.object({
  deviceId: z.string().min(1)
});

export const heartbeatDeviceSchema = z.object({
  deviceId: z.string().min(1),
  appVersion: z.string().optional()
});

export type ActivateDeviceInput = z.infer<typeof activateDeviceSchema>;
export type RevokeDeviceInput = z.infer<typeof revokeDeviceSchema>;
export type HeartbeatDeviceInput = z.infer<typeof heartbeatDeviceSchema>;

export interface DeviceActivationInput {
  deviceFingerprint?: string;
  deviceName?: string;
  platform?: string;
  appVersion?: string;
}

export interface DeviceHeartbeatInput {
  deviceId: string;
  appVersion?: string;
}
